import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
Vue.use(require('vue-moment'));

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.min.js'

Vue.config.productionTip = false
//Pages
import LoginPage from './components/Login.vue'
import RegisterPage from './components/Register.vue'
import GoodbyePage from './components/Goodbye.vue'
import RegSuccessPage from './components/RegSuccess.vue'
import DashboardPage from './components/Dashboard.vue'
import ProfilePage from './components/Profile.vue'
import ProjectPage from './components/ProjectView.vue'
import ProjectListPage from './components/ProjectList.vue'
import NotFoundPage from './components/404.vue'

const routes = [
  { path: '/', component: DashboardPage },
  { path: '/login', component: LoginPage },
  { path: '/logout', component: GoodbyePage },
  { path: '/profile', component: ProfilePage },
  { path: '/profile/:id', component: ProfilePage },
  { path: '/project/:id', component: ProjectPage },
  { path: '/join/:invite', component: ProjectPage },
  { path: '/projects/:type/:status', component: ProjectListPage },
  { path: '/registration-success', component: RegSuccessPage },
  { path: '/register', component: RegisterPage },
  { path: '/404', component: NotFoundPage },
  { path: '*', component: NotFoundPage },
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for `routes: routes`
  mode: 'history',
})

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
